import React from 'react';
import PropTypes from 'prop-types';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import '../../styles/global.scss';
import Menu from '../../components/Menu';

const MainLayout = ({ children }) => {
    return (
        <div className="container mx-auto">
            <Header />
            <div className="main-container flex md:space-x-6 lg:space-x-10 px-4 lg:px-6 1xl:px-10 pt-28 lg:pt-36 pb-6">
                <Menu />
                <div className="content-container w-full">
                    <main role="main">{children}</main>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

MainLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default MainLayout;
